<div class="flex h-full flex-col gap-4 rounded-4xl border-2 border-background-white bg-background-white p-6 shadow-modal">
  <div class="relative flex items-center p-2.5">
    <button class="btn-text absolute mr-4 text-h4 font-semibold leading-[15px] text-primary-blue" (click)="cancel()">
      <svg-icon key="px-16-arrow-left" class="text-text-black"></svg-icon>
      {{ 'perio_exam_settings_modal_back_button' | translate }}
    </button>
    <div class="flex w-full justify-center">
      <span class="typo-h2 font-semibold">
        {{ 'perio_exam_settings_modal_missing_teeth_title' | translate }}
      </span>
    </div>
  </div>
  <div class="flex flex-grow flex-col items-center">
    <lib-teeth
      class="!w-auto"
      [currentTeeth]="teeth"
      [drawCross]="true"
      [drawLabels]="false"
      [drawBackgroundLines]="false"
      [missingTeethView]="true"
      [missingTeeth]="missingTeethPositions()"
      [extractedTeeth]="extractedTeethPositions"
      (clicked)="toothClicked($event)"
    />
    <div class="flex w-full items-center justify-end gap-8">
      <button class="btn-text" (click)="cancel()">
        {{ 'perio_exam_settings_modal_missing_teeth_cancel_button' | translate }}
      </button>
      <button class="btn-primary" (click)="saveChanges()">
        {{ 'perio_exam_settings_modal_missing_teeth_save_button' | translate }}
      </button>
    </div>
  </div>
</div>
